'use client';

import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { getBgClassNames } from '@nx-frontend/shared/themes/utils';
import { PortalBgType, ThemeColorSchemas } from '@nx-frontend/shared/types';

interface ThemeCardProps {
  themeName: string;
  thumbnail: string;
  themeColors: ThemeColorSchemas;
  onDetailedSettings?: () => void;
  selected?: boolean;
  showStatus?: boolean;
  showEdit?: boolean;
  showActiveLabel?: boolean;
}

export const ThemeCard: React.FC<ThemeCardProps> = ({
  selected,
  themeName,
  thumbnail,
  themeColors,
  showStatus = false,
  showActiveLabel,
  showEdit = true,
  onDetailedSettings,
}) => {
  const t = useTranslations('shared');
  return (
    <>
      <div className="flex flex-row items-center justify-between w-full">
        <h2 className="text-sm font-semibold">{themeName}</h2>
        {(selected && showStatus) || showActiveLabel ? (
          <span className="px-2 py-1 bg-green-50 text-green-600 text-xs font-medium rounded-lg">
            {t('image-selector.active')}
          </span>
        ) : null}
      </div>
      <div className="flex pt-4 justify-start items-center gap-1.5">
        <div
          className={classNames('border border-neutral-200 rounded-lg h-8 w-8')}
          style={{ backgroundImage: `url(${thumbnail})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        ></div>

        {[PortalBgType.PRIMARY, PortalBgType.SURFACE_INNER_HOVER, PortalBgType.SECONDARY].map((bgType, key) => (
          <div
            key={key}
            className={classNames(
              'border border-neutral-200 rounded-lg h-8 w-8 shrink-0',
              ...getBgClassNames(themeColors, bgType)
            )}
          ></div>
        ))}
        {selected && showEdit && (
          <div className="w-7 h-7 flex justify-center items-center ml-auto" onClick={onDetailedSettings}>
            <Icon icon={IconsMap.PENCIL} className="text-neutral-500 size-5" />
          </div>
        )}
      </div>
    </>
  );
};
